// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YZlW","colBig":"styles_colBig__2d1nP","colSmall":"styles_colSmall__3toIG","shopifyNameWrapper":"styles_shopifyNameWrapper__1d1qt"};